/**
 * FulfillmentConstants — Centralized keys for fulfillment state.
 * Used by FulfillmentState, LocationCatalogPricing, theme.liquid inline script.
 */
(function () {
  'use strict';

  const FulfillmentConstants = {
    COMMITTED: 'et_fulfillment_committed',
    DATE: 'selected_fulfillment_date',
    TIME: 'selected_fulfillment_time',
    LOCATION_ID: 'selected_location_id',
    LOCATION_NAME: 'selected_location_name',
    DELIVERY_TYPE: 'selected_delivery_type',
    ZIP_CODE: 'selected_zip_code',
    TIME_ZONE: 'selected_time_zone',
    CATALOG_ID: 'selected_catalog_id',
    CATALOG_KEY_PREFIX: 'location_catalog_json',
    ZIP_CACHE_PREFIX: 'zipCache-',
  };

  FulfillmentConstants.FULFILLMENT_KEYS = [
    FulfillmentConstants.DATE,
    FulfillmentConstants.TIME,
    FulfillmentConstants.LOCATION_ID,
    FulfillmentConstants.LOCATION_NAME,
    FulfillmentConstants.DELIVERY_TYPE,
    FulfillmentConstants.ZIP_CODE,
    FulfillmentConstants.TIME_ZONE,
    FulfillmentConstants.CATALOG_ID
  ];

  window.FulfillmentConstants = FulfillmentConstants;
  const DEFAULT_TIME_ZONE = 'America/Los_Angeles';

  function isValidTimeZone(timeZone) {
    const tz = typeof timeZone === 'string' ? timeZone.trim() : '';
    if (!tz) return false;
    try {
      const formatter = new Intl.DateTimeFormat('en-US', { timeZone: tz });
      return formatter.resolvedOptions().timeZone === tz;
    } catch (e) {
      return false;
    }
  }

  function getSafeTimeZone(timeZone) {
    return isValidTimeZone(timeZone) ? timeZone.trim() : DEFAULT_TIME_ZONE;
  }

  const FulfillmentDateUtils = {
    getSelectedTimeZone: function () {
      try {
        return getSafeTimeZone(window.EtStorage.local.getItem(FulfillmentConstants.TIME_ZONE));
      } catch (e) {
        return DEFAULT_TIME_ZONE;
      }
    },

    getTodayStringInTimeZone: function (timeZone) {
      const tz = getSafeTimeZone(timeZone || this.getSelectedTimeZone());
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date());

        const yearPart = parts.find(function (p) { return p.type === 'year'; });
        const monthPart = parts.find(function (p) { return p.type === 'month'; });
        const dayPart = parts.find(function (p) { return p.type === 'day'; });
        const year = yearPart ? yearPart.value : null;
        const month = monthPart ? monthPart.value : null;
        const day = dayPart ? dayPart.value : null;
        if (year && month && day) {
          return year + '-' + month + '-' + day;
        }
      } catch (e) {}

      const now = new Date();
      const yyyy = now.getFullYear();
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const dd = String(now.getDate()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd;
    },

    isSelectedDateToday: function (selectedDate, timeZone) {
      if (!selectedDate) return false;
      return String(selectedDate) === this.getTodayStringInTimeZone(timeZone);
    },

    getTodayDateForComparison: function (timeZone) {
      const todayStr = this.getTodayStringInTimeZone(timeZone);
      return new Date(todayStr + 'T12:00:00');
    }
  };

  window.FulfillmentDateUtils = FulfillmentDateUtils;
})();
